import {Language} from '../../context/LanguageContext';
import './index.scss';

export default function PrivacyPolicy() {
  const {language, newObj} = Language();
  return (
    <div
      className='privacy_policy_ctr'
      dangerouslySetInnerHTML={{__html: newObj.PrivacyPolicyPage[language]}}
    ></div>
  );
}
